module.exports = __webpack_public_path__ + "static/media/bg-image-46.db7390d1.jpg";